import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { isAuthenticatedSelector, userSelector } from '../../selectors/authSelectors';
import { useFetchQDeckUsersQuery } from '../../api/qdeckApi';

const PrivateRoute = ({ component: Component, isAuthenticated, ...routeProps }) => {
  const user = useSelector(userSelector);
  const { data: qdeckUsers = [], isLoading: areQDeckUsersLoading } = useFetchQDeckUsersQuery();
  const isUserQDeckUser = qdeckUsers.some((qdeckUser) => qdeckUser.email === user.email);

  return (
    <Route
      {...routeProps}
      render={(props) =>
        (() => {
          if (!isAuthenticated) {
            return <Redirect to='/' />;
          }

          if (!areQDeckUsersLoading && !isUserQDeckUser && routeProps.path !== '/unauthorized') {
            return <Redirect to='/unauthorized' />;
          }

          return <Component {...props} />;
        })()
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticatedSelector(state)
});

export default connect(mapStateToProps)(PrivateRoute);
